"use strict";
import globals from "../globals";
var privateFns, layer, zIndex;
privateFns = {
	startSpy: function(layerId, btn){
		var mousePosition = null;
		var container = document.getElementById('map');
		layer = globals.map.getLayerById(layerId);
		globals.map.removeLayer(layerId);
		layer.values_.layerId = "layerSpy";
		layer.setVisible(true);
		var map = globals.map;
		map.getLayers().push(layer);
		var radius = 75;
		document.addEventListener('keydown', function(evt) {
			if (evt.which === 38) {
				radius = Math.min(radius + 5, 150);
				map.changed();
				evt.preventDefault();
			} else if (evt.which === 40) {
				radius = Math.max(radius - 5, 25);
				map.changed();
				evt.preventDefault();
			}
		});
		container.addEventListener('mousemove', function(event) {
			mousePosition = map.getEventPixel(event);
			map.changed();
		});
		layer.on(["precompose", "prerender"], function(event) {
			var ctx = event.context;
			var pixelRatio = event.frameState.pixelRatio;
			ctx.save();
			ctx.beginPath();
			if (mousePosition) {
				// only show a circle around the mouse
				ctx.arc(mousePosition[0] * pixelRatio, mousePosition[1] * pixelRatio,
				radius * pixelRatio, 0, 2 * Math.PI);
				ctx.lineWidth = 5 * pixelRatio;
				ctx.strokeStyle = 'rgba(0,0,0,0.5)';
				ctx.stroke();
			}
			ctx.clip();
			layer.getSource().changed();
		});

		// after rendering the layer, restore the canvas context
		layer.on(["postcompose", "postrender"], function(event) {
			var ctx = event.context;
			ctx.restore();
			layer.getSource().changed();
		});
		
	},
	deactivate: function(id){
		var toolTipWin, showWin;
		toolTipWin = $("#layer-spy-tool-help");
		showWin = localStorage.getItem("planinnsyn-"+id);
		if(layer){				
			layer.setVisible(false);
		}
		if(toolTipWin){
			toolTipWin.hide();					
		}
	},
	spyClick: function(e, layerId){
		var btn = $(e.currentTarget);
		if(btn.toggleClass){
			btn.toggleClass("selected");
			btn.blur();
			var toolTipWin = undefined, showWin = undefined;
			toolTipWin = $("#layer-spy-tool-help");
			showWin = localStorage.getItem("planinnsyn-"+btn.attr("id"));
		}
		if(layer && layer.values_.visible){
			privateFns.deactivate(btn.attr("id"));
		}else if (layer && !layer.values_.visible){
			layer.setVisible(true);
			if (toolTipWin.is(":visible") === false) {
				if(showWin === null){
					toolTipWin.show();
				}
				if(!showWin){
					toolTipWin.show();
				}
			}
		}else{
			privateFns.startSpy(layerId, btn);
			if (toolTipWin.is(":visible") === false) {
				if(showWin === null){
					toolTipWin.show();
				}
				if(!showWin){
					toolTipWin.show();
				}
			}
		}
	},
}

export default {
	deactivate: privateFns.deactivate,
	registerPluginFunction: function(registerFunction, callback){
		registerFunction({
			id: "layer-spy",
			deactivate: privateFns.deactivate,
			onclick: privateFns.spyClick,
		}, callback)
	},
};
